/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import phrasesType from '../proptypes/phrases';
import ScoreCard from './ScoreCard';
import summaryContentType from '../proptypes/summary-content';
import { statsMainType } from '../proptypes/special-ops';
import { getTakeAwaySocial } from '../lib/take-away-video-utils';
import SocialSharing from './SocialSharing';
import StatList from './StatList';
import ScoreCardSection from './ScoreCardSection';
import { DataDescription } from './Typography';
import SpecialOpsVideoCardCarousel from './SpecialOpsVideoCardCarousel';
import { vunit } from '../lib/style-helpers';

const createGetRoundTitle = ({ headings: { latestScores, round } }) => (roundNumber = 0, totalRounds) => (roundNumber === 0 ? latestScores : `${round} ${totalRounds - roundNumber}`);

const HeroWrapper = styled.div`
  padding-bottom: ${vunit(1)};
  padding-top: ${vunit(2)};
`;

const ScoreCardSpecialOps = ({
  imageUrl,
  gameKey,
  summary,
  stats,
  sessions,
  specialOpsVideoUrl,
  specialOpsVideoPagePath,
  videosBeingProcessed,
  phrases,
  noVideoSessionImageUrl,
}) => {
  const [selectedRound, setSelectedRound] = useState(0);
  const selectedSession = sessions[selectedRound];
  const takeAwaySocial = getTakeAwaySocial(
    selectedSession,
    stats[selectedRound].score,
    phrases,
    specialOpsVideoPagePath,
  );
  const getRoundTitle = createGetRoundTitle(phrases);

  return (
    <ScoreCard
      {...{
        gameTitle: phrases.gameTitle,
        imageUrl,
        gameKey,
        summary,
      }}
      heroOverride={(
        <HeroWrapper>
          <div className="special-ops-score-card-stats">
            <SpecialOpsVideoCardCarousel
              stats={stats}
              sessions={sessions}
              specialOpsVideoUrl={specialOpsVideoUrl}
              videosBeingProcessed={videosBeingProcessed}
              phrases={phrases}
              onSlideChange={setSelectedRound}
              noVideoSessionImageUrl={noVideoSessionImageUrl}
            />
          </div>
        </HeroWrapper>
      )}
    >
      <ScoreCardSection>
        <DataDescription large>{getRoundTitle(selectedRound, sessions.length)}</DataDescription>
      </ScoreCardSection>
      <ScoreCardSection>
        <StatList {...stats[selectedRound]} />
      </ScoreCardSection>
      <SocialSharing
        networks={takeAwaySocial}
        namespace="special-ops-score-card"
      />
    </ScoreCard>
  );
};

ScoreCardSpecialOps.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  gameKey: PropTypes.string.isRequired,
  summary: summaryContentType.isRequired,
  stats: PropTypes.arrayOf(statsMainType).isRequired,
  sessions: PropTypes.arrayOf(PropTypes.string).isRequired,
  specialOpsVideoUrl: PropTypes.string.isRequired,
  specialOpsVideoPagePath: PropTypes.string.isRequired,
  phrases: phrasesType.isRequired,
  videosBeingProcessed: PropTypes.arrayOf(PropTypes.bool).isRequired,
  noVideoSessionImageUrl: PropTypes.string.isRequired,
};

export default ScoreCardSpecialOps;
